import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { IBlockNumberSchema } from "../../Schemas/BlockNumber";

interface Filter extends IFilterSchema {
  column: BlockNumbersListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: BlockNumbersListColumnSortable;
}

export enum BlockNumbersListColumnFilterable {
  ID = "id",
  DESCRIPTION = "description",
  GROUP = "group",
  NUMBER = "number",
  PARTNER_ID = "partner_id",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}
export enum BlockNumbersListColumnSortable {
  ID = "id",
}

interface BlockNumbersListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface BlockNumbersListResponseBody extends IResponseBody {
  data: {
    block_numbers: IBlockNumberSchema[];
    total: number;
  };
}

export class BlockNumbersListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/block-numbers`;
  }

  async list(
    queryStrings?: BlockNumbersListQueryString
  ): Promise<BlockNumbersListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
